import styled, { css } from 'styled-components'
import { StyledInput } from '../inputs/FormInput'

interface BackgroundBase {
  $color?: string,
  $gradient?: {
    angle?: number,
    steps: {
      [key: number]: string,
    },
  },
  $image?: string,
  $borderTop?: string,
  $borderBottom?: string,
}

interface BackgroundMask extends BackgroundBase {
  $color: string,
  $mask: string,
  $maskPosition: 'top' | 'bottom',
}

type Background = BackgroundBase | BackgroundMask

const Background = styled.div<Background>`
  position: relative;
  
  ${ p => p.$color && !( '$mask' in p && p.$mask ) && css`
    background-color: ${ p.theme.getColor( p.$color ) };
  ` }
  
  ${ p => p.$color === 'black' && css`
    color: ${ p.theme.colors.white };
  ` }

  ${ p => p.$gradient && css`
    background: linear-gradient( 
      ${ p.$gradient.angle || 0 }deg,
      ${ Object.entries( p.$gradient.steps )
    .map( ( [position, color] ) => `${ p.theme.getColor( color ) } ${ position }%` ) 
    .join( ', ' )
} );
  ` }

  ${ p => p.$image && css`
    background-image: url( ${ p.$image } );
    background-size: cover;
  ` }

  ${ p => p.$borderTop && css`
    border-top: 1px solid ${ p.theme.getColor( p.$borderTop ) };
  ` }

  ${ p => p.$borderBottom && css`
    border-bottom: 1px solid ${ p.theme.getColor( p.$borderBottom ) };
  ` }

  ${ p => '$mask' in p && p.$mask && css`
    position: relative;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      background: ${ p.theme.getColor( p.$color ) };
      mask-repeat: repeat-x;

      ${ p.$maskPosition === 'top' && css`
        top: -15px;
        bottom: 0;
        mask-image:
          url( ${ p.$mask } ),
          linear-gradient( transparent 10%, rgb( 0, 0, 0 ) 10%, rgb( 0, 0, 0 ) 90% );
        mask-position: top center;
      ` }

      ${ p.$maskPosition === 'bottom' && css`
        top: 0;
        bottom: -60px;
        mask-image:
          url( ${ p.$mask } ),
          linear-gradient( rgb( 0, 0, 0 ) 90%, rgb( 0, 0, 0 ) 10%, transparent 10% );
        mask-position: top center;
      ` }
    }
  ` }

  ${ p => p.$color === 'navy' && css`
    ${ StyledInput } {
      label {
        color: ${ p.theme.colors.white };
      }
    }
  ` }
`

Background.defaultProps = {
  $mask: null,
  $maskPosition: 'top',
}

export default Background
